// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import get from 'lodash/get'
import { Query } from 'react-apollo'
import { i18n } from '../../index'
import Loader from '../../../common/loader/Loader'
import StationPage from '../station/StationPage'
import ShiftResponsibilityPage from './ShiftResponsibilityPage'
import { fetchStationShiftResponsibilities } from '../../shiftResponsibility/shiftResponsibilityQueries'

function StationShiftResponsibilityPage() {
  return (
    <StationPage title={i18n.t('admin.stations.title.shiftResponsibilities')}>
      {({ station }) => (
        <Query
          query={fetchStationShiftResponsibilities}
          variables={{
            stationId: station.id,
          }}
          fetchPolicy='network-only'
        >
          {({ loading, error, data }) => (
            <Loader
              {...{
                loading,
                error,
              }}
            >
              <ShiftResponsibilityPage data={get(data, 'stationShiftResponsibilities', [])} stationId={station.id} />
            </Loader>
          )}
        </Query>
      )}
    </StationPage>
  )
}

export default StationShiftResponsibilityPage
